import styled from 'styled-components';

export const TabsContainer = styled.div`
  display: flex;
  gap: 32px;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 24px;
  width: 150px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const Tab = styled.button`
  background: none;
  border: none;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  color: ${({ $active }) => ($active ? '#2d6cdf' : '#6c757d')};
  padding: 12px 0;
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease;

  &:hover {
    color: #2d6cdf;
  }

  ${({ $active }) =>
    $active &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background: #2d6cdf;
    }
  `}
`;
